import { useParams } from 'react-router-dom'

import { PageHeader, ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Upload } from '@factorialco/f0-react/icons/app'
import { PayrollCyclesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import {
  getPayrollRunStatusText,
  getPayrollRunStatusVariant,
} from 'modules/compensations/lib/payrollRunStatus'

const PayrollCycleDetails = () => {
  const { id } = useParams()
  const cycleId = Number(id)

  const { loading, data: cyclesData } = useQuery(PayrollCyclesDocument, {
    variables: {
      ids: [cycleId],
    },
    context: {
      isBookkeeperView: true,
    },
  })

  const payrollRun = cyclesData?.compensations.payrollRunsConnection.nodes?.[0]

  if (loading) return <Loading />

  return (
    <>
      <PageHeader
        module={{
          href: '/professionals/clients/payroll-cycles',
          id: 'compensations',
          name: i18n.t('bookkeepers.clients.payroll_cycles.title'),
        }}
        breadcrumbs={[
          {
            href: `/professionals/clients/payroll-cycles/${id}/details`,
            id: 'cycles-details',
            label: payrollRun?.cycle?.company?.name ?? '',
          },
        ]}
      />

      <ResourceHeader
        title={payrollRun?.cycle?.company?.name ?? ''}
        status={{
          label: i18n.t('bookkeepers.clients.payroll_cycles.list_columns.status'),
          text: getPayrollRunStatusText(payrollRun?.status ?? ''),
          variant: getPayrollRunStatusVariant(payrollRun?.status ?? ''),
        }}
        metadata={[
          {
            label: i18n.t('bookkeepers.clients.payroll_cycles.list_columns.period'),
            value: {
              type: 'text',
              content: payrollRun?.label ?? '',
            },
          },
        ]}
        secondaryActions={[
          {
            label: 'Export variables',
            onClick: () => {},
            icon: Upload,
            disabled: payrollRun?.status === 'in_preparation',
          },
        ]}
      />
    </>
  )
}

export default PayrollCycleDetails
